import { DatePipe, formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { contractorType } from 'src/app/models/ContractorType';
import { EmployeeUploadInfo } from 'src/app/models/employee-upload-info';
import { EmployeeDto } from 'src/app/models/EmployeeDto';
import { NotificationType } from 'src/app/models/notification.message';
import { ApproveEmployeeUploadVM } from 'src/app/models/requests/ApproveEmployeeUploadVM';
//import { ApproveEmployeeUploadVM } from 'src/app/models/requests/ApproveEmployeeUploadVM';
import { SkillDto } from 'src/app/models/SkillDto';
import { UploadedEmployeeInfo } from 'src/app/models/uploaded-employee';
import { ApproveContractsComponent } from 'src/app/pages/approvecontract/approvecontracts.component';
import { ContractsService } from 'src/app/services/contracts.service';
import { EmployeesService } from 'src/app/services/employees.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SkillsService } from 'src/app/services/skills.service';

@Component({
  selector: 'app-verify-employee-detail',
  templateUrl: './verify-employee-detail.component.html',
  styleUrls: ['./verify-employee-detail.component.css']
})
export class VerifyEmployeeDetailComponent implements OnInit {

  title: string = '';
  setOfCheckedId = new Set<number>();
  setOfCheckedIdMedical = new Set<number>();
  setOfCheckedIdBiometric = new Set<number>();

  checked = false;
  checkedMedical = false;
  checkedBiometric = false;

  NumberofActiveEmployees: number = 0;

  indeterminate = false;
  indeterminateMedical = false;
  indeterminateBiometric = false;

  listOfCurrentPageData: readonly UploadedEmployeeInfo[] = [];

  listOfCurrentPageDataMedical: readonly UploadedEmployeeInfo[] = [];
  listOfCurrentPageDataBiometric: readonly UploadedEmployeeInfo[] = [];

  Skills: SkillDto[] = [];
  defaultStartDate: Date = new Date();
  defaultEndDate: Date = new Date();
  id: number = 0;
  Employees: UploadedEmployeeInfo[] = [];
  selectedEmployees: UploadedEmployeeInfo[] = [];
  selectedEmployeesMedical: UploadedEmployeeInfo[] = [];
  selectedEmployeesBiometric: UploadedEmployeeInfo[] = [];

  ActiveEmps: EmployeeDto[] = [];

  contractorType = contractorType;
  loading: boolean = true;
  dateFormat = 'yyyy-MM-dd';
  EmployeeData: any;
  ViewEmployeeVisible: boolean = false;
  medicalNotes:string='';
  safetyInductionNotes:string='';
  isBiometricRequired:boolean=false;
  isMedicalRequired:boolean=false;

  



  constructor(private contractService: ContractsService, private fileUploaddservice: FileUploadService, private skillService: SkillsService, private route: ActivatedRoute, private employeeService: EmployeesService, public datepipe: DatePipe,
    private router: Router, private notification: NotificationService, private employeesService: EmployeesService) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.params['id']
    this.loadData(this.id);
    this.loading = false;
    this.LoadDropDowns();
  }
  async LoadDropDowns() {

    let resSkills = await this.skillService.getSkills().toPromise();
    this.Skills = <SkillDto[]>resSkills.responseData;


    //


  }

  async loadData(id: number) {
    let resUploads = await this.employeeService.getUploadedEmployee(id).toPromise();
    this.Employees = <UploadedEmployeeInfo[]>resUploads.responseData;
    console.log("this is employees ", this.Employees);
    var contractId = this.Employees[0].contractId;
    var type = this.Employees[0].type;
    let employees = await this.employeeService.getActiveEmployeesByRequest(contractId,type).toPromise();
    if (employees) { this.NumberofActiveEmployees = employees.responseData.length; }


    let contract = await this.contractService.getById(contractId).toPromise();
    this.title = 'Employees Upload for ' + contract.responseData.reference + '(' + contract.responseData.contractorName + ')';;

    ;
  }

  updateCheckedSet(data: UploadedEmployeeInfo, checked: boolean): void {

    if (checked) {

      this.setOfCheckedId.add(data.id);

      const itemToPushIndex = this.selectedEmployees.findIndex(function (item) {
        return item.id === data.id;
      });
      if (itemToPushIndex == -1) {
        this.selectedEmployees.push(data);
      }

    } else {
      this.setOfCheckedId.delete(data.id);

      const itemToRemoveIndex = this.selectedEmployees.findIndex(function (item) {
        return item.id === data.id;
      });

      // proceed to remove an item only if it exists.
      if (itemToRemoveIndex !== -1) {
        this.selectedEmployees.splice(itemToRemoveIndex, 1);
      }


    }
  }

  async open(data: UploadedEmployeeInfo) {
    this.EmployeeData = data;
    this.ViewEmployeeVisible = true;
  }

  close(): void {
    this.ViewEmployeeVisible = false;
  }

  onItemChecked(data: UploadedEmployeeInfo, checked: boolean): void {
    this.updateCheckedSet(data, checked);
    this.refreshCheckedStatus();
  }

  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: readonly UploadedEmployeeInfo[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }

  sendRequest(): void {
    ;
    this.loading = true;
    const requestData = this.Employees.filter(data => this.setOfCheckedId.has(data.id));



    if (this.selectedEmployees.length > 0) {
    
      ;
      const approempVM: ApproveEmployeeUploadVM = {} as ApproveEmployeeUploadVM;
      approempVM.fileId = this.id;
      approempVM.models = this.selectedEmployees;
      approempVM.medicalNotes = this.medicalNotes;
     // approempVM.safetyInductionNotes = this.safetyInductionNotes;
      approempVM.isBiometricRequired =this.isBiometricRequired;
      approempVM.isMedicalRequired = true;

      console.log(approempVM);
      ;
      this.employeeService.approveEmployeeUpload(approempVM).subscribe({
        next: (data => {
          
          if (data.responseCode == "00") {
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });

            setTimeout(() => {
              this.setOfCheckedId.clear();
              this.refreshCheckedStatus();
              this.loading = false;
            }, 1000);


            this.router.navigate(['verifyemployees']);

          }
          else {
            setTimeout(() => {
              //  this.setOfCheckedId.clear();
              //this.refreshCheckedStatus();
              this.loading = false;
            }, 1000);
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });

          }

        }),
        error: ((error: any) => {

          setTimeout(() => {
            //  this.setOfCheckedId.clear();
            //this.refreshCheckedStatus();
            this.loading = false;
          }, 1000);
          this.notification.sendMessage({
            message: error.error.message,
            type: NotificationType.error
          });
        })

      });


    }
    else {

      this.notification.sendMessage({
        message: 'No record selected',
        type: NotificationType.error
      });

    }


  }


  //#region  medical
  onAllCheckedMedical(value: boolean): void {

    if (value) {
      this.checkedMedical = true;
      this.isBiometricRequired=true;
      this.listOfCurrentPageData.forEach(x1 => x1.isMedicalRequired = true);
    }
    else {
      this.checkedMedical = false;
      this.isBiometricRequired=false;
      this.listOfCurrentPageData.forEach(x1 => x1.isMedicalRequired = false);
    }

    // this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item, value));
    this.refreshCheckedStatus();
  }
  //#endregion


  //#region  Biometrics
  onAllCheckedBiometric(value: boolean): void {
;
    if (value) {
      this.checkedBiometric = true;
      this.listOfCurrentPageData.forEach(x1 => x1.isBiometricRequired = true);
      this.isBiometricRequired = true;
    }
    else {
      this.checkedBiometric = false;
      this.listOfCurrentPageData.forEach(x1 => x1.isBiometricRequired = false);
      this.isBiometricRequired = false;

    }

    // this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item, value));
    this.refreshCheckedStatus();
  }
  //#endregion


  onChangeStartDate(result: Date): void {

    if (result) {
      this.defaultStartDate = result;
      this.listOfCurrentPageData.forEach(x1 => x1.startDate = result);

      this.refreshCheckedStatus();
    }

  }


  onChangeEndDate(result: Date): void {

    if (result) {
      this.defaultEndDate = result;
      this.listOfCurrentPageData.forEach(x1 => x1.endDate = result);
      this.refreshCheckedStatus();
    }

  }

  onChangeSkill(result: any): void {

    if (result) {
      // this.defaultStartDate = result;
      this.listOfCurrentPageData.forEach(x1 => x1.skillId = result.target.value);

      this.refreshCheckedStatus();
    }

  }

  onChangeCategory(result: any): void {
    this.listOfCurrentPageData.forEach(x1 => x1.employeeClass = result.target.value);
    this.refreshCheckedStatus();
  }

  functionToDeleteItem() {

    ;
    if (this.id) {
      this.fileUploaddservice.DeleteFile(this.id).subscribe({
        next: (data => {
          
          if (data.responseCode == "00") {
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });

            this.router.navigate(['verifyemployee']);



          }
          else {

            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });

          }

        }),
        error: ((error: any) => {

          this.notification.sendMessage({
            message: error.error.message,
            type: NotificationType.error
          });
        })

      });
    }


  }

  cancel() { return; }
}




